// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1WjCu","newExpiryDate":"styles_newExpiryDate__GF6RV","footer":"styles_footer__3wZnv"};